// export const API_BASE_URL = 'http://localhost:8052';
export const API_BASE_URL = 'https://www.litttlebear.tw/api';

export const API_ENDPOINTS = {
  CAMP_SEARCH: `${API_BASE_URL}/camps/search`,
  CAMP_TAGS: `${API_BASE_URL}/camps/tags`,
  CAMP_BASE: `${API_BASE_URL}/camps`,
};
